import { graphql, useStaticQuery } from 'gatsby';
import get from 'lodash.get';
import React from 'react';

import { ReactComponent as Logo } from '../../images/fs-logo.svg';
import { ReactComponent as LinkedIn } from '../../images/icons/sharing/linkedin.svg';
import { ReactComponent as Twitter } from '../../images/icons/sharing/twitter.svg';
import ContentContainer from '../Common/ContentContainer';
import PageSection from '../Common/PageSection';
import SmartLink from '../Common/SmartLink';
import * as styles from './Footer.module.css';

const Footer = ({ isSpark = false, dark, className }) => {
  const data = useStaticQuery(graphql`
    query {
      settings: contentfulSiteSettings(contentful_id: { eq: "3vxKUCou9H8hWkqL5dcaNm" }) {
        nav: footerNavigation {
          menuItems {
            ... on ContentfulMenuItem {
              title
              url
              isNoFollow
              subMenuItems {
                ... on ContentfulMenuItem {
                  title
                  url
                  isNoFollow
                }
              }
            }
          }
        }
        subnav: footerSubNavigation {
          menuItems {
            ... on ContentfulMenuItem {
              ...MenuItem
            }
          }
        }
      }
    }
  `);
  const { settings } = data;
  const cookieClasses = [styles.cookieList, 'ot-sdk-show-settings'].join(' ');

  const onShowModal = () => {
    if (window) {
      window.Osano?.cm.showDoNotSell();
    }
  };

  const footerMenu = settings.nav.menuItems.map((item, i) => {
    const subNav = get(item, 'subMenuItems', []);
    return (
      <ul key={i} className={[styles.menu, 'unstyled-list'].join(' ')}>
        <li>
          <h5>{item.title}</h5>
          {subNav && (
            <ul>
              {subNav.map((sub, s) => {
                return (
                  <li key={s}>
                    <SmartLink rel={sub.isNoFollow ? 'nofollow' : ''} to={sub.url}>
                      {sub.title}
                    </SmartLink>
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      </ul>
    );
  });

  return (
    <>
      <PageSection className={[className, isSpark && styles.sparkFooter].join(' ')}>
        <SmartLink to="/" className={styles.logo}>
          <Logo aria-label="FullStory Logo" role="img" />
        </SmartLink>
        <footer className={[styles.siteFooter, dark ? styles.dark : ''].join(' ')}>
          {isSpark && (
            <nav className={styles.nav}>
              <ul key="spark-company" className={[styles.menu, 'unstyled-list'].join(' ')}>
                <li>
                  <h5>Company</h5>
                  <ul>
                    <li key="spark-about-us">
                      <SmartLink to="/about-us/">About us</SmartLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          )}
          <nav className={styles.socialNav}>
            <h5>Follow along</h5>
            <div className={styles.social}>
              <SmartLink to="https://www.twitter.com/fullstory">
                <Twitter />
              </SmartLink>
              <SmartLink to="https://www.linkedin.com/company/fullstory">
                <LinkedIn />
              </SmartLink>
            </div>
          </nav>
          {!isSpark && <nav className={styles.nav}>{footerMenu}</nav>}
        </footer>
      </PageSection>
      <section className={styles.subSection}>
        <ContentContainer>
          <footer className={styles.subFooterPink}>
            <nav className={styles.copyright}>
              <p>© {new Date().getFullYear()} FullStory, Inc | Atlanta ◆ London ◆ Sydney ◆ Hamburg ◆ Singapore</p>
            </nav>
            <nav className={styles.subNav}>
              <div className={styles.cookieButtons}>
                <button onClick={onShowModal}>Do Not Share</button>{' '}
                <button
                  className={cookieClasses}
                  onClick={() => {
                    if (window) {
                      window.Osano?.cm.showDrawer('osano-cm-dom-info-dialog-open');
                    }
                  }}
                >
                  Cookie Settings
                </button>
              </div>
            </nav>
          </footer>
        </ContentContainer>
      </section>
    </>
  );
};

export default Footer;
